export default __webpack_public_path__ + "static/media/2-bg.3dce135d.png";